export default "__VITE_ASSET__Cu5S$LNw__"